import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../translate';
import { newFormatPrice } from '../../../services/utilityFunctions';
import PriceProp from '../../propTypes/priceProp';
import ImageProp from '../../propTypes/imageProp';

const AcademyPaymentItem = props => {
  const { t, item, checkoutDetail, showPrices, participants } = props;
  const { userPrice, userPromotionPrice, name, image } = item;
  const { item: itemCheckout } = checkoutDetail;
  let imageToShow = '/images/game_default.png';
  let price = t('free');
  let total;
  let tax;
  let code;

  if (userPrice && userPrice.total > 0) {
    price = userPrice.price;
    total = userPrice.total;
    tax = userPrice.tax;
    code = userPrice.code;
  }
  if (userPromotionPrice && userPromotionPrice.total > 0) {
    price = userPromotionPrice.price;
    total = userPromotionPrice.total;
    tax = userPromotionPrice.tax;
    code = userPromotionPrice.code;
  }
  if (image && image.thumb && image.thumb.length > 0) {
    imageToShow = image.thumb;
  }
  return (
    <div className="academy-payment-item row">
      <img src={imageToShow} alt={name} className="col-lg-3 col-12 remove-padding-col" />
      <div className="col-lg-5 col-12">
        <h4 className="">{name || ''}</h4>
        {participants && participants.length > 0 && (
          <div className="participants-container-display">
            <span className="label">Participants:</span>
            <span className="participants">{participants.length}</span>
          </div>
        )}
      </div>
      {showPrices && (
        <>
          <div className="academy-prices col-lg-2 col-6 remove-padding-col divider-prices">
            <span>{`${t('checkout.payment.vatExcl')}.`}</span>
            <h4 className="no-wrap-value">{newFormatPrice(itemCheckout?.subtotal || price, true, code)}</h4>
          </div>
          <div className="academy-prices col-lg-2 col-6 remove-padding-col">
            <span>{`${t('checkout.payment.vatInc')}. ${itemCheckout?.tax || tax}%`}</span>
            <h4 className="no-wrap-value">{newFormatPrice(itemCheckout?.total || total, true, code)}</h4>
          </div>
        </>
      )}
    </div>
  );
};

AcademyPaymentItem.propTypes = {
  t: PropTypes.func.isRequired,
  showPrices: PropTypes.bool,
  checkoutDetail: PropTypes.shape({
    item: PropTypes.shape({
      tax: PropTypes.number,
      total: PropTypes.number,
      price: PropTypes.number,
    }),
  }).isRequired,
  item: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    userPrice: PropTypes.shape(PriceProp.PropTypes),
    userPromotionPrice: PropTypes.shape(PriceProp.PropTypes),
    name: PropTypes.string.isRequired,
    image: PropTypes.shape(ImageProp.propType).isRequired,
  }).isRequired,
  participants: PropTypes.arrayOf(PropTypes.string),
};

AcademyPaymentItem.defaultProps = {
  showPrices: true,
  participants: null,
};

export default translate(AcademyPaymentItem);
